<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import FileUpload from '@components/inputs/file-upload.svelte'
  import { Globe } from 'lucide-svelte'

  let { form, resource = null, file = $bindable(null), cover_image = $bindable(null), useUrl = $bindable(false) } = $props()

  let urlInput = $state(null)

  // If useUrl changes to be true and the URL is empty, focus it
  $effect(() => {
    if (useUrl) setTimeout(() => urlInput?.select(), 0)
  })

</script>

<Page.Content class="gap-6 xl:flex-row xl:items-start">

  <main class="xl:w-[66%] flex flex-col gap-6">
    <Form.Fieldset label="Details">
      <Form.Items>
        <Form.Item name="name" bind:value={$form.name} label="Name" hint="The name of the resource" cols={8} required />
        <Form.Item name="color" bind:value={$form.color} label="Color" type="color" cols={4} required />
        <Form.Item
          name="use_url" bind:value={useUrl} label="Resource type" type="segmented-control"
          options={[{ label: "File", value: false }, { label: "URL", value: true }]}
          cols={12}
        />
        {#if useUrl}
          <Form.Item bind:inputRef={urlInput} name="url" bind:value={$form.url} label="URL" cols={12} placeholder="https://..." required>
            {#snippet prefix()}
              <Globe size={16} class="text-gray-400" />
            {/snippet}
          </Form.Item>
        {:else}
          <FileUpload label="File" files={file ? [file] : []} onChange={files => file = files[0]} maxCount={1} class="col-span-12" showInputIfFull={false} required={!file} />
        {/if}
      </Form.Items>
    </Form.Fieldset>

    <Form.Fieldset label="Description">
      <Form.Item name="description" hint="Will appear on the resource page" type="richtext" bind:value={$form.description} />
    </Form.Fieldset>
  </main>

  <aside class="xl:w-[31%] flex flex-col gap-6">
    <Form.Fieldset label="Cover image">
      <FileUpload files={cover_image ? [cover_image] : []} onChange={files => cover_image = files[0] || null} maxCount={1} showInputIfFull={false} />
    </Form.Fieldset>

    <Form.Fieldset label="Tags">
      <Form.Item name="tag_ids" type="autocomplete" multiple bind:value={$form.tag_ids} url="api/v1/tags" loadAll labelKey="name" valueKey="id" placeholder="Search tags…" />
    </Form.Fieldset>
  </aside>

</Page.Content>
